import "./backFixedButton.css";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
const BackFixedButton = (props) => {
  const navigate  = useNavigate()
  const backBtnHandler = () => {
    navigate(props?.backPage?props.backPage:-1,
      {
        state: {
          fromBackUrl: props?.url
        }
      }
      )
  };
  return (
    // <div 
    // className={`back-btn ${props?.btnStyle}`}
    // onClick={backBtnHandler}
    // >
    //    <IoIosArrowBack className="back-icon" />
    //   <button
    //     // className={` ${props?.btnStyle}`}
    //   >
    //     {props?.btnName}
    //   </button>
    // </div>
    <div className="btn btn-primary btn-pill" onClick={backBtnHandler}>
      
      <i class="ti-arrow-left me-1"></i> {props?.btnName}
    </div>
  );
};

export default BackFixedButton;
